import React, { useState, useEffect } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { BACKGROUND_COLOR } from 'src/utils/const';

import AuthorizedView from './AuthorizedView';
import UnAuthorizedView from './UnAuthorizedView';

import { callApi } from 'src/core/callApi';

import {
  activeMarketsArrayType
} from "./ActiveMarkersConst";

const backgroundStyle = {
  backgroundColor: BACKGROUND_COLOR,
  width: '100vw',
  minHeight: '100vh',
};

const ActiveMarkets = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [markets, setMarkets] = useState<null | activeMarketsArrayType[]>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const callActiveMarketsApi = async () => {
      const url =
        'https://d9zdctpij7.execute-api.us-east-2.amazonaws.com/default/getActiveSubscribedMarkets';

      const res: any = await callApi(url, {}, true);

      if ('Error' in res) {
        setIsAdmin(false);
        setIsLoading(false);
        return;
      }

      if (res?.markets.length > 0) {
        setMarkets(res.markets);
        setIsAdmin(true);
        setIsLoading(false);
      }

      return;
    };

    callActiveMarketsApi();
  }, []);

  if (isLoading) {
    return (
      <div style={backgroundStyle}>
        <div
          style={{
            height: '100vh',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress />
        </div>
      </div>
    );
  }

  return (
    <div style={backgroundStyle}>
      {isAdmin ? (
        <AuthorizedView markets={markets as activeMarketsArrayType[]} />
      ) : (
        <UnAuthorizedView />
      )}
    </div>
  );
};

export default ActiveMarkets;
